import { FC, useEffect, useState } from 'react';
import styles from './AppointmentInfo.module.scss'

import calendar from 'shared/assets/calendar.svg'
import geo from 'shared/assets/iconfinder_geo.svg'
import { Image } from 'shared/ui/image';

type AppointmentInfoProps = {
  clinics: string[] | string;
  start?: string;
}

export const AppointmentInfo: FC<AppointmentInfoProps> = ({
  clinics,
  start = null,
}) => {

  const [ startDateStr, setStartDateStr ] = useState<string>('')

  useEffect(() => {
    if (start) {
      const startDate = new Date(start);
  
      setStartDateStr(startDate.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit'
      }))
    }
  }, [start])

  if (!start) return <></>;

  return (
    <div className={styles.appointmentInfo}>
      {Array.isArray(clinics) ? clinics.map((clinic, index) => {
        return (
          <div className={styles.appointmentInfo__item} key={index}>
            <i>
              <Image 
              src={geo}
              size='24px'
              />
            </i>
            <span>{clinic}</span>
          </div>
        )
      }) : 
      <div className={styles.appointmentInfo__item}>
        <i>
          <Image 
          src={geo}
          size='24px'
          />
        </i>
        <span>{clinics}</span>
      </div>
      }
      <div className={styles.appointmentInfo__item}>
        <i>
          <Image 
          src={calendar}
          size='24px'
          />
        </i>
        <span>{startDateStr}</span>
      </div>
    </div>
  )
}